export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["اسم:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حفظ"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رجوع"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["يرجى تقديم اسم جديد للأصل"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["سيساعدك هذا الاسم في التعرف على المحفظة بسهولة أكبر في قائمة الأصول الخاصة بك."])}
}